import { RefObject } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

type LottieFileProps = {
  animationData: object;
  lottieRef: RefObject<LottieRefCurrentProps | null>;
};

export default function LottieFile({ animationData, lottieRef }: LottieFileProps) {
  return <Lottie lottieRef={lottieRef} animationData={animationData} loop={false} autoplay={false} />;
}
